class StoreCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.carousel-tiendas__track');
    this.slides = Array.from(this.querySelectorAll('.carousel-tiendas__slide'));
    this.dots = Array.from(this.querySelectorAll('.carousel-tiendas__dot'));
    this.prevBtns = Array.from(this.querySelectorAll('[data-direction="prev"]'));
    this.nextBtns = Array.from(this.querySelectorAll('[data-direction="next"]'));
    this.current = 0;

    this.prevBtns.forEach((btn) => btn.addEventListener('click', () => this.go(this.current - 1)));
    this.nextBtns.forEach((btn) => btn.addEventListener('click', () => this.go(this.current + 1)));

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.go(i));
    });

    if (this.track) {
      this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
    }

    const autoplay = this.getAttribute('data-autoplay') === 'true';
    const interval = parseInt(this.getAttribute('data-autoplay-interval') || '5000', 10);
    if (autoplay && this.slides.length > 1) {
      this.timer = setInterval(() => {
        const next = (this.current + 1) % this.slides.length;
        this.go(next);
      }, interval);
    }
  }

  go(index) {
    if (!this.slides.length) return;
    const clamped = Math.max(0, Math.min(index, this.slides.length - 1));
    this.current = clamped;
    const slide = this.slides[clamped];
    if (slide && this.track) {
      this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }
    this.updateDots();
  }

  onScroll() {
    if (!this.track) return;
    const scrollLeft = this.track.scrollLeft;
    let closest = 0;
    let closestDist = Infinity;
    this.slides.forEach((slide, i) => {
      const dist = Math.abs(slide.offsetLeft - scrollLeft);
      if (dist < closestDist) {
        closestDist = dist;
        closest = i;
      }
    });
    if (closest !== this.current) {
      this.current = closest;
      this.updateDots();
    }
  }

  updateDots() {
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.current);
    });
  }
}

customElements.define('store-carousel', StoreCarousel);
